///////////////
// FAST CRAWL
//////////////

export enum FastCrawlFlowStates {
  Unstarted = "Unstarted",
  CredentialsVerified = "CredentialsVerified",
  UserCrawled = "UserCrawled",
  TeammatesIdentified = "TeammatesIdentified",
  InvitesSuggested = "InvitesSuggested",
  TeammatesEventsCrawled = "TeammatesEventsCrawled",
  CalendarAliasesResolved = "CalendarAliasesResolved",
  TeammatesEventsSaved = "TeammatesEventsSaved",
  Finished = "Finished",
}

export const FatalFastCrawlFlowStates = [
  FastCrawlFlowStates.Unstarted,
  FastCrawlFlowStates.CredentialsVerified,
  FastCrawlFlowStates.UserCrawled,
  FastCrawlFlowStates.CalendarAliasesResolved,
  FastCrawlFlowStates.TeammatesIdentified,
  FastCrawlFlowStates.InvitesSuggested,
];
